import { useCallback, useSyncExternalStore } from 'react'

let isPolicyAccepted = false
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => isPolicyAccepted

const setPolicyAccepted = (accepted: boolean) => {
  if (isPolicyAccepted === accepted) return
  isPolicyAccepted = accepted
  listeners.forEach((listener) => listener())
}

export const usePolicyAcceptance = () => {
  const accepted = useSyncExternalStore(subscribe, getSnapshot)

  const setAccepted = useCallback((value: boolean) => {
    setPolicyAccepted(value)
  }, [])

  return { isPolicyAccepted: accepted, setIsPolicyAccepted: setAccepted }
}
